import { player } from 'src/client/player';
import { popoutPlayer } from 'src/client/popout';
import { requestPopoutPlayerDialog } from '../../common/actions/dialog';
import {
  OPEN_POPOUT_PLAYER,
  setPopoutPlayerStatus,
} from '../../common/actions/player';
import { FAILED, PLAYING } from '../../common/actions/tuner';
import { selectIsUserSubscribed } from '../../common/selectors/me';

// TODO: delete middleware after Player Manager migration is complete
export default ({ getState, dispatch }) =>
  (next) =>
  (action) => {
    // Move the action down the middleware pipeline first since
    // nothing here needs to execute before the action makes it
    // to the reducers.
    next(action);

    if (player.isActive) {
      return;
    }

    const state = getState();
    const {
      player: { tunedGuideId },
      app: { partnerId },
    } = state;
    const { type, failedWithHttp } = action;

    switch (type) {
      case PLAYING:
        if (popoutPlayer.isOpen) {
          popoutPlayer.close();
        }
        break;
      case FAILED:
        if (failedWithHttp && popoutPlayer.isEnabled) {
          dispatch(setPopoutPlayerStatus());
          dispatch(requestPopoutPlayerDialog());
        }
        break;
      case OPEN_POPOUT_PLAYER: {
        const isPremium = selectIsUserSubscribed(state);

        popoutPlayer.openOrUpdate({
          guideId: tunedGuideId,
          isPremium,
          partnerId,
        });
        break;
      }
      default:
    }
  };
